export const errors = {
  'Page not available': 'Página não disponível',
  'Something went wrong, please try again later.':
    'Algo deu errado, por favor tente novamente mais tarde.',
  Home: 'Início',
};
